module.exports = __webpack_public_path__ + "static/14-0f31cd3234b47c24d7fcb8d4d77b051d.jpg";